// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1LZTK","productName":"Table_productName__3OZJ3"};